export default function(object)
{
	const lines = []

	object.label && lines.push(object.label)
	object.address && lines.push(object.address)
	object.address2 && lines.push(object.address2)
	object.address3 && lines.push(object.address3)

	if ( object.city || object.postal_code || object.country_code || object.country )
	{
		const line = []

		object.postal_code && line.push(object.postal_code)
		object.city && line.push(object.city)
		object.country_code && line.push(object.country_code)
		!object.country_code && object.country && line.push(object.country)

		lines.push(line.join(' '))
	}

	return lines
}